import React, { useState, useEffect, useCallback } from 'react';
import _ from 'lodash'
import { useLocation, withRouter, useHistory } from 'react-router-dom';
import { useModal, Loader } from '@jutro/components';
import { withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { Wizard } from '@xengage/gw-portals-wizard-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useTranslator } from '@jutro/locale';
import { LoadSaveService } from 'twia-capability-quoteandbind-residential';
import { wizardMessages } from 'twia-portals-wizard-components-ui';
import wizardConfig from './config/twia-commercial-wizard-config.json5';
import TWIAWizardHelper from 'producer-engage/src/overrides/modules-react/twia-portals-wizard-components-ui/Wizard/components/util/TWIAWizardHelper';

const TWIACommercialWizard = (props) => {
    const translator = useTranslator();
    const [initialSubmission, setInitialSubmission] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const authHeader = _.get(useAuthentication(), 'authHeader');
    const location = useLocation();
    const history = useHistory();
    const { steps, title } = wizardConfig;
    const { viewModelService } = props;
    const { showConfirm } = useModal();
 
    const {postalCode, quoteID} = _.get(location, 'state.quoteentry');

    const retrieveSubmission = useCallback(() => {
        if (authHeader) {
            const requestData = {quoteID, postalCode}

            LoadSaveService.retrieveSubmission(requestData, authHeader).then((response)=>{
                const responseSubmission = viewModelService.create(
                    response, 
                    'pc', 
                    'edge.capabilities.quote.submission.dto.QuoteDataDTO');
                
                setInitialSubmission(responseSubmission);
                setIsLoading(false);
            })
        }
    }, [authHeader, postalCode, quoteID, viewModelService]);

    useEffect(()=>{
        retrieveSubmission()
    },[retrieveSubmission, authHeader])

    if (isLoading) {
        return <Loader loaded={!isLoading} />
    }

    const getSteps = () => {
        const shouldHideStep = initialSubmission?.value?.baseData?.periodStatus === 'Submitted_Ext';

        return shouldHideStep ? steps.filter(step => step.id === 'PaymentDetailsPage' || step.id === 'PaymentDetails') : steps
    }

    const onCancelWithProps = wizardObj => {
        const redirectPath = _.get(wizardObj, 'param', `/quotes/${quoteID}/summary`);
        const wizardSnapshot = wizardObj.wizardSnapshot;
        const wizardData = wizardObj.wizardData;
        const cancelProps = { wizardSnapshot, wizardData, showConfirm, translator, wizardMessages, setIsLoading, history, redirectPath, authHeader };

        return TWIAWizardHelper.handleCancel(cancelProps);
    }

    return (
        <Wizard
            initialSteps={getSteps()}
            wizardTitle={title}
            initialData={initialSubmission}
            location={location}
            skipCompletedSteps
            onCancel={onCancelWithProps}
            onPreviousModalProps={{ title: wizardMessages.TWIAWizardModalTitle,
                message: wizardMessages.TWIAWizardModalMessage,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: wizardMessages.TWIAWizardModalConfirm,
                cancelButtonText: wizardMessages.TWIAWizardModalCancel,
            }}
        />

    )
}

export default withRouter(withViewModelService(TWIACommercialWizard));
